export const tokenPath = (): string =>
  'account/ecommerce_api_token/'

export const orderTemplatesPath = (): string =>
  'api/v1/ordertemplate/'

export const orderTemplateTypesPath = (): string =>
  'api/v1/ordertemplate/types/'

export const orderTemplateGroupsPath = (): string =>
  'api/v1/ordertemplate/groups/'

export const productVariantFilterPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/variant-filter/`

export const productFilterAttributesPath = (productId: number): string =>
  `xhr/product/get_filter_attributes/${productId}`
